import styled from "@emotion/styled";
import { useTranslation } from "next-i18next";
import numeral from "numeral";
import { useState } from "react";
import { EVENT, send } from "@/lib/amplitude";
import DownloadDialog from "./DownloadDialog";
import ShareDialog from "./ShareDialog";

const DubbedSocial = ({
  idx,
  is_mine,
  video,
  itemSeq,
  code,
  like_count,
  comment_count,
  share_count,
  handlePause,
  locale,
}: {
  idx: number;
  is_mine: boolean;
  video: any;
  itemSeq: number;
  code: string;
  like_count: number;
  comment_count: number;
  share_count: number;
  handlePause: () => void;
  locale: any;
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const { t } = useTranslation();

  const handleClickLikeShowDialog = (event: any) => {
    send(EVENT.CLICK__LIKE_BTN_ON_DUBBED_PAGE, {
      dubbed_idx: idx,
      is_mine,
      item_seq: itemSeq,
    });

    event.stopPropagation();
    handlePause();
    setIsDialogOpen(true);
  };

  const handleClickReplyShowDialog = (event: any) => {
    send(EVENT.CLICK__COMMENT_BTN_ON_DUBBED_PAGE, {
      dubbed_idx: idx,
      is_mine,
      item_seq: itemSeq,
    });

    event.stopPropagation();
    handlePause();
    setIsDialogOpen(true);
  };

  const handleClickShare = (event: any) => {
    send(EVENT.CLICK__SHARE_BTN_ON_DUBBED_PAGE, {
      dubbed_idx: idx,
      is_mine,
      item_seq: itemSeq,
    });

    event.stopPropagation();
    handlePause();
    setIsShareOpen(true);
  };

  return (
    <Section>
      <TextIcon onClick={handleClickLikeShowDialog}>
        <Icon className="icon icon-like" />
        <Text>
          {like_count > 1
            ? numeral(like_count).format("0,0")
            : t("dubbed_like")}
        </Text>
      </TextIcon>
      <TextIcon onClick={handleClickReplyShowDialog}>
        <Icon className="icon icon-reply" />
        <Text>
          {comment_count > 1
            ? numeral(comment_count).format("0,0")
            : t("dubbed_review")}
        </Text>
      </TextIcon>
      <TextIcon onClick={handleClickShare}>
        <Icon className="icon icon-share" />
        <Text>
          {share_count > 1
            ? numeral(share_count).format("0,0")
            : t("button_share")}
        </Text>
      </TextIcon>
      <DownloadDialog
        dubbedIdx={idx}
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        locale={locale}
      />
      <ShareDialog
        code={code}
        isShareOpen={isShareOpen}
        setIsShareOpen={setIsShareOpen}
        locale={locale}
        dubbedIdx={idx}
        videoIdx={video.idx}
        isMine={is_mine}
        itemSeq={itemSeq}
      />
    </Section>
  );
};

const Section = styled.div`
  width: 45px;
  position: absolute;
  bottom: 80px;
  right: 20px;
  z-index: 3;
`;

const TextIcon = styled.div`
  width: 45px;
  height: 52px;
  margin-bottom: 12px;
  text-align: center;
  :last-of-type {
    margin-bottom: 0;
  }
`;

const Icon = styled.div`
  font-size: 32px;
  color: white;
`;

const Text = styled.div`
  font-size: var(--fs-c1);
  line-height: var(--lh-c1);
  font-weight: 400;
  color: white;
`;

export default DubbedSocial;
